import { BRAND_CONFIG_COLLECTIONS } from '../config';
import { Environment, isValidEnv } from '../../environments';

/**
 * Returns a brand that has been pre-configured on the site and is identified
 * using the provided identifier. To successfully retrieve a brand, a brand
 * config must have been created previously for the expected environment and
 * must contain the expected domain identifiers.
 * 
 * @param { string } domain - The domain used to find the brand.
 * @param { string } environment - The environment to retrieve the brand from.
 * @returns { { id: string, name: string, brandIdentifiers: string[], metadata: object } }
 */
function getBrandConfigByIdentifier( domain, environment ) {
    // Validate arguments.
    environment = ( environment === Environment.LOCAL ) ? Environment.QA : environment;
    if ( !domain || !isValidEnv( environment ) ) {
        return undefined;
    }

    // Retrieve a list of all brand groups (collections of brand configurations made
    // available to a particular environment) for the provided environment and flatten
    // them to be a single array of brand configs. This is only necessary if there are
    // multiple groups created for a single environment.
    const brandGroups = BRAND_CONFIG_COLLECTIONS.filter( ( brandGroup ) => ( brandGroup.environment === environment ) );
    let brandConfigs = [].concat( ...brandGroups.map( brandGroup => brandGroup?.brands || [] ) );

    // Find and return the id of the brand config that contains an identifier found in
    // the provided domain/URL.
    for ( let i = 0; i < brandConfigs.length; i++ ) {
        const brandConfig = brandConfigs[ i ];
        const brandIdentifiers = brandConfig?.brandIdentifiers || [];
        const identifierMatch = brandIdentifiers.some( ( identifier ) => domain.includes( identifier ) );
        if ( identifierMatch ) {
            return brandConfig;
        }
    }

    return undefined;
}

export default getBrandConfigByIdentifier;